import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    manneList: []
};

const getters = {
    getManne: state => state.manneList
};

const actions = {
    getManne({commit}) {
        axiosGet(`crm/mannes?all`).then(({data}) => {
            commit('MANNE_INFO', data)
        }).catch((error) => console.log(error));
    },
};

const mutations = {
    MANNE_INFO(state, data) {
        state.manneList = data;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
